<template>
    <div class="select">
        <select class="" @change="onValueChanged">
            <slot></slot>
        </select>
    </div>
</template>

<script>
export default {
    props: ['value'],

    methods: {
        onValueChanged($event) {
            this.$emit('input', $event.target.value);
            this.$emit('change', $event.target.value);
        }
    }
};
</script>
